import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import BaseMediaPlayerPage from '@ts-core/pages/BaseMediaPlayerPage';

import { useMediaItems, useMediaItem } from 'modules/media/hooks';

const MediaPlayerPage = () => {
  const history = useHistory();
  const { courseId, subjectId, mediaItemId } = useParams();

  const { mediaItems, loading: loadingMediaItems, error: mediaItemsError } = useMediaItems({ courseId, subjectId });

  const { mediaItem, loading: loadingMediaItem, error: mediaItemError } = useMediaItem({ courseId, subjectId, mediaItemId });

  const onSelectMediaItem = useCallback(
    (targetMediaItem) => {
      history.push(`/${courseId}/subjects/${subjectId}/media/${targetMediaItem._id}/player`);
    },
    [history, courseId, subjectId]
  );

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/subjects/${subjectId}/media`);
  }, [history, courseId, subjectId]);

  return (
    <BaseMediaPlayerPage
      mediaItems={mediaItems}
      allowDownload
      loadingMediaItems={loadingMediaItems}
      allMediaItemsError={mediaItemsError}
      selectedMediaItem={mediaItem}
      loadingSelectedMediaItem={loadingMediaItem}
      selectedMediaItemError={mediaItemError}
      onSelectMediaItem={onSelectMediaItem}
      onGoBack={onGoBack}
    />
  );
};

export default MediaPlayerPage;
